import moment from 'moment';
import React from 'react';
import {
   Image,
   Text,
   TouchableOpacity,
   View,
   Platform,
   Dimensions,
} from 'react-native';
import {
   white,
   FONT_FAMILY_REGULAR,
   isNewAPI,
   listItemBG,
   isWeb,
   isHoverEnabled,
   LIST_HOVER_COLOR,
} from '../../utils/utils';
import {isTablet} from 'react-device-detect';

const windowWidth = isWeb ? window.innerWidth : Dimensions.get('window').width;
//iPad mini width 1133
const expiryMarginEnd = windowWidth <= 1133 ? 15 : 29;

const MyTrainingItem = props => {
   const isValid = isNewAPI ? props.item.IsValid : props.item.isValid;
   const [isHover, setHover] = React.useState(false);
   return (
      <TouchableOpacity
         onPress={() => {
            props.onItemClick();
         }}
         onMouseEnter={() => {
            setHover(true);
         }}
         onMouseLeave={() => {
            setHover(false);
         }}
         style={{
            flexDirection: 'row',
            backgroundColor:
               isHover && isHoverEnabled ? LIST_HOVER_COLOR : listItemBG,
            borderRadius: 4,
            marginTop: 8,
            padding: 4,
            marginHorizontal: 12,
            alignContent: 'center',
            alignItems: 'center',
            justifyContent: 'center',
         }}>
         <Text
            style={{
               flex: 1,
               marginStart: 12,
               fontSize: 12,
               padding: 8,
               color: '#000000',
               fontFamily: FONT_FAMILY_REGULAR,
               fontWeight: '600',
            }}>
            {isNewAPI ? props.item.CourseName : props.item.coursename}
         </Text>
         {props.isLandscap ? (
            <Text
               style={{
                  flex: 0.3,
                  fontSize: 12,
                  marginEnd: 10,
                  color: '#000000',
                  fontFamily: FONT_FAMILY_REGULAR,
                  fontStyle: 'italic',
                  fontWeight: '600',
               }}>
               {moment(props.item.CompletedDate).format('MMMM DD, YYYY')}
            </Text>
         ) : null}
         {props.isLandscap ? (
            <Text
               style={{
                  flex: 0.3,
                  fontSize: 12,
                  marginEnd: expiryMarginEnd,
                  color: '#000000',
                  fontStyle: 'italic',
                  fontFamily: FONT_FAMILY_REGULAR,
                  fontWeight: '600',
               }}>
               {props.item.ExpiryDate !== 'n/a'
                  ? moment(props.item.ExpiryDate).format('MMMM DD, YYYY')
                  : 'No Expiry'}
            </Text>
         ) : null}
         <View
            style={{
               backgroundColor: isValid ? '#26E555' : '#808080',
               borderRadius: 4,
               height: 32,
               width: 32,
               alignContent: 'center',
               alignItems: 'center',
               justifyContent: 'center',
            }}>
            <Image
               style={{
                  ...Platform.select({
                     web: {
                        width: 16,
                        height: 16,
                     },
                  }),
               }}
               source={require('../../assets/single_tick.png')}
            />
         </View>
      </TouchableOpacity>
   );
};

export default MyTrainingItem;
